import {useAppDispatch} from "../../../../hooks/hooks";
import {useUtil} from "../../../../util/hooks/useUtil";
import {useCallback} from "react";
import {OrganShareDeallocateDTO} from "../../../../types/organShare";
import {deallocateAuthorityAsync} from "../../../../store/organShareSlice";

export function useOrganShareAction() {
    const dispatch = useAppDispatch();
    const {defaultErrorMessage} = useUtil();

    // 소속 정보 리스트
    const deallocateAuthority = useCallback(
        async (dto: OrganShareDeallocateDTO) => {
            try {
                await dispatch(deallocateAuthorityAsync(dto)).unwrap();
                window.alert("선택한 소속의 읽기 권한을 삭제했습니다.")
            } catch (e) {
                alert(defaultErrorMessage);
            }
        },
        //eslint-disable-next-line
        []
    );

    return{
        deallocateAuthority
    }
}